module.exports = __webpack_public_path__ + "static/img/sc3.e423988.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc3.png
// module id = Dwpu
// module chunks = 25